/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTranslation } from 'react-i18next';

const EmptySearchResult = ({ searchedString }) => {
  const { t } = useTranslation();
  return (
    <div className="empty-search-result-card">
      <div className="heading">
        {t('sorryWeCouldnTFindAnyResultsFor')} '{searchedString}'{' '}
      </div>
      <div className="subHeading">
        <p>{t('wordsSpelledCorrectly')}</p>
        <p>{t('tryDifferentKeyWords')}</p>
      </div>
    </div>
  );
};

export default EmptySearchResult;
